import React, { Component } from 'react';
import { Bar } from 'react-chartjs-2';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import DashboardMobileNav from '../../../navigation.components/DashboardMobileNav';
import UserDashBoardSideNavigation from
  '../../userDashBoard.components/UserDashBoardSideNavigation';
import UserDashBoardTopNavigation from '../../userDashBoard.components/UserDashBoardTopNavigation';
import MeepInvestModal from '../../../modals/MeepInvest';
import fetchMtLip from '../../../../actions/investment.actions/mtLipActions/getMtlip.action';

/**
 * @class ReapPage
 */
class MTLIPPage extends Component {

  state = {
    Data: {}
  }

  /**
   *
   * @returns {*} - mtlip investment
   */
  componentWillMount() {
    const { FetchMtLip } = this.props;
    FetchMtLip();
  }

  /**
   *
   * @returns {*} - chart
   */
  componentDidMount() {
    this.setState({
      Data: {
        labels: 'MT-LIP Investment',
        datasets: [
          {
            label: 'Investments',
            data: [12, 19, 3, 5, 2, 3, 15],
            backgroundColor: [
              'rgba(255,105,145,0.6)',
              'rgba(155,100,210,0.6)',
              'rgba(90,178,255,0.6)',
              'rgba(240,134,67,0.6)',
              'rgba(120,120,120,0.6)',
              'rgba(250,55,197,0.6)'
            ]
          }
        ]
      }
    });
  }

  /**
   *
   * @returns {*} - render
   */
  render() {
    const { history } = this.props;
    const { Data } = this.state;
    const mTLIPage = (
      <section className="body_space">
        <div className="go_back">
          <span onClick={history.goBack}>
            <i className="fa fa-arrow-left" aria-hidden="true" />
            {' '}
            {'  '}
             Go Back
          </span>
        </div>
        <div className="invest_detail_top">
          <div className="title">
            <h5
              style={{
                color: '#898D92',
              }}
            >
    Investment Details
            </h5>
          </div>
          <div className="invest_btn green_btn">
            <button
              type="button"
              data-toggle="modal"
              data-target="#meep_settings"
            >
        Invest Now
            </button>
          </div>
        </div>
        <div className="invest_detail_desc">
          <div className="left" />
          <div className="right">
            <div className="right_header">
              <h4>
              MT-LIP
              </h4>
              <p>
              This Fund invests in low risk, short-term securities such as Government securities, Bank
placements and others including Commercial Papers and promissory notes. This mutual

MERISTEM MUTUAL FUNDS

fund is for investors who value liquidity and security of assets. It is open-ended and
constituted under a Trust Deed.
              </p>
            </div>
            <div className="right_footer">
              <div>
                <p>
                Interest
                </p>
                <p>
                0% monthly
                </p>
              </div>

              <div>
                <p>
                Minimum investment amount

                </p>
                <p style={{ color: 'black', fontSize: '14px' }}>
                ₦ 10,000.00
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="chart_section mt-5">
          {/* <canvas id="myChart" /> */}
          <Bar
            data={Data}
            options={{ maintainAspectRatio: true }}
          />
        </div>

        <div className="container text-center"
          style={{
            padding: '20px'
          }}
        >
          <h4
            style={{
              color: 'black',
              fontFamily: 'Open Sans',
            }}
          >
            Features and Benefits
          </h4>
        </div>
        <div className="container text-center">
          <div
            style={{
              fontSize: '12px',
              color: 'black'
            }}
          >
            <p>
            Preserves and grows capital.
            </p>
            <p>
            Steady stream of income.
            </p>
            <p style={{ color: '#10C06D' }}>
            Open to both resident and foreign investors.
            </p>
            <p>
            Tax free interest income.
            </p>
            <p style={{ color: '#10C06D' }}>
            Quarterly distribution of returns or reinvestment of same.
            </p>
            <p style={{ color: '#10C06D' }}>
            Unit holders return on investment is tax free.
            </p>
            <p>
            Tax free capital gains from redemption of units by unit holders
            </p>
            <p style={{ color: '#10C06D' }}>
            Minimum subscription amount: N10, 000
            </p>
            <p>
            Termination within 30-day period attracts 0.5% penalty charge on accrued return
            </p>
          </div>
        </div>

      </section>
    );
    return (
      <>
        <DashboardMobileNav />
        <UserDashBoardSideNavigation />
        <div className="main_body_wrapper">
          <UserDashBoardTopNavigation />
          {mTLIPage}
        </div>
        <MeepInvestModal />
      </>
    );
  }
}

MTLIPPage.propTypes = {
  FetchMtLip: PropTypes.func,
  history: PropTypes.shape({}),
};

export default withRouter(connect(null, {
  FetchMtLip: fetchMtLip
})(MTLIPPage));
